import React, { useEffect, useRef, useState } from "react";
import Alert from "@mui/lab/Alert";
import { ClinicOnboardView } from "./clinicOnboardView";
import { SignUpLink } from "./signLinks";
import { ClinicSmallLink } from "../elements/ClinicSmallLink";
import { getLastSelectedClinicId } from "../clinicManage";
import {
  getCurrentUserEmail,
  KAHUN_PLATFORM,
} from "user-management/src/cognito/kahunUserAuth";

import { CLINIC_MANAGE_URL } from "../clinicSettings/clinicUrls";
import { LoginFormMui } from "user-management/src/components/loginFormMui";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicLoginProps {
  gotoSignUp: () => void;
  gotoForgotPassword: () => void;
  onLogin: (clinicId?: string) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicLogin = ({ onLogin, ...props }: ClinicLoginProps) => {
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [isRedirecting, setIsRedirecting] = useState(false);

  const isMounted = useRef<boolean>(true);

  useEffect(() => {
    return () => void (isMounted.current = false);
  }, []);

  const handleLogin = async () => {
    setIsRedirecting(true);
    try {
      // Avoid warnings exit the function if component got unmounted
      if (!isMounted.current) return;

      let requestedClinicId = sessionStorage.getItem("requestedClinicId"); //get the saved clinic id from before login
      if (requestedClinicId) sessionStorage.removeItem("requestedClinicId");
      else
        requestedClinicId = getLastSelectedClinicId(
          await getCurrentUserEmail(),
        ); //otherwise get the last viewed clinic

      onLogin(requestedClinicId || "");
    } finally {
      if (isMounted.current) setIsRedirecting(false);
    }
  };

  const handleLoginLoading = () => {
    setErrMsg("");
    setLoading(true);
  };
  const handleError = (msg: string) => {
    setErrMsg(msg);
    setLoading(false);
  };
  return (
    <ClinicOnboardView title="Login to Kahun" errMsg={errMsg}>
      {isRedirecting && <Alert severity="success">Redirecting...</Alert>}
      {/*<LoginForm*/}
      {/*  onSignIn={handleLogin}*/}
      {/*  keepLoading={loading || isRedirecting}*/}
      {/*  onLoading={handleLoginLoading}*/}
      {/*  onError={handleError}*/}
      {/*  platform={KAHUN_PLATFORM.ClinicManage}*/}
      {/*  socialLoginRedirect={CLINIC_MANAGE_URL}*/}
      {/*/>*/}
      <LoginFormMui
        onSignIn={handleLogin}
        onLoading={handleLoginLoading}
        onError={handleError}
        keepLoading={loading || isRedirecting}
        platform={KAHUN_PLATFORM.ClinicManage}
        enableGoogleLogin
        socialLoginRedirect={CLINIC_MANAGE_URL}
      />
      <div style={{ marginTop: 12, textAlign: "center" }}>
        <ClinicSmallLink onClick={props.gotoForgotPassword}>
          Forgot your password?
        </ClinicSmallLink>
      </div>
      <SignUpLink goToSignUp={props.gotoSignUp} />
    </ClinicOnboardView>
  );
};
